<nav class="navbar navbar-expand-lg d-none d-lg-flex shadow navbar-light bg-light">
    <div class="container-fluid" style="width: 93%;">
        <a class="navbar-brand" [routerLink]="['/app/dashboard']">
            <img src="assets/images/logo-flat.svg" width="250px" height="50px" alt="ALDDA">
        </a>
        <div class="collapse navbar-collapse ml-auto">
            <ul class="nav navbar-nav h6 text-secondary w-100 d-flex align-items-center">
                <li class="nav-item ms-auto">
                    <button class="nav-link btn btn-warning text-white text-uppercase px-3" (click)="contactModal.openModal()">Sala de soporte</button>
                </li>
                <li class="nav-item ms-3 dropdown">
                    <span dropdown>
                        <a href id="basic-link" class="nav-link dropdown-toggle" dropdownToggle (click)="false" aria-controls="basic-link-dropdown">
                        <span class="rounded-circle p-2 mr-1" style="background-color: #009D89;"><i class="far fa-user fa-lg text-white"></i></span> {{userInfo.name}}
                        </a>
                        <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right rounded-0" style="z-index: 2000;"
                            role="menu" aria-labelledby="basic-link">
                            <li><a class="dropdown-item border-bottom border-1 py-2 cursor-pointer" (click)="goToProfile()">Mi Cuenta</a></li>
                            <!-- <li><a class="dropdown-item border-bottom border-1 py-2 cursor-pointer" (click)="goToSO()">Sujeto Obligado</a></li> -->
                            <li><a class="dropdown-item border-bottom border-1 py-2 cursor-pointer" (click)="goToHelpCenter()">Centro de Capacitación</a></li>
                            <li><a class="dropdown-item cursor-pointer py-2" (click)="logoutModal.openModal()">Logout</a></li>
                        </ul>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</nav>

<app-contact-modal #contactModal></app-contact-modal>
<app-logout-modal #logoutModal></app-logout-modal>